// extracted by css-extract-rspack-plugin
export default {"tickle":"Tickle-module__tickle__eOqI3","copilotRun":"Tickle-module__copilotRun__D1wqf"};